import { render, staticRenderFns } from "./ModalStock.vue?vue&type=template&id=153afeb5&scoped=true&"
import script from "./ModalStock.vue?vue&type=script&lang=js&"
export * from "./ModalStock.vue?vue&type=script&lang=js&"
import style0 from "./ModalStock.vue?vue&type=style&index=0&id=153afeb5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "153afeb5",
  null
  
)

export default component.exports